// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"2677ec26","453":"2dee7a69","980":"ba2cc1ae"}[chunkId] + ".chunk.js";
};